import { Group, Page, PageRequest } from '$synapse/models';
import { GroupService } from '$synapse/services';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GroupsPageResolver {
  private readonly _groupsApi = inject(GroupService);

  resolve(route: ActivatedRouteSnapshot) {
    return this._groupsApi.findAll(
      new PageRequest(route.queryParams).setDefaultSort('name,asc')
    );
  }
}
